import { filterSelector } from '@src/store/common/selectors';
import { uuidv4 } from '@src/utils';
import { atom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const uuidAtom = atom('');

export const useGlobalFilterUUID = () => {
  const setUUID = useSetAtom(uuidAtom);
  const globalFilters = useSelector(filterSelector);

  useEffect(() => {
    setUUID(uuidv4());
  }, [globalFilters, setUUID]);
};
